<template>
	<BaseCard class="shadow-toast flex items-center gap-3 rounded-xl p-3" alt>
		<div
			class="flex h-6 w-6 shrink-0 items-center justify-center rounded-lg"
			:class="{
				'bg-[#0AC63C]': type === 'success',
				'bg-label-tertiary': type === 'info',
				'bg-[#E01533]': type === 'error'
			}"
		>
			<Component :is="icon" class="text-label-primary h-4.5 w-4.5" />
		</div>
		<div class="text-label-primary flex-1 text-sm font-medium">{{ text }}</div>
		<div
			class="text-label-tertiary shrink-0 px-1 text-sm font-medium whitespace-nowrap"
			v-hover="{ active: 'scale-90', impact: 'soft' }"
			@click="act"
		>
			{{ actionText }}
		</div>
	</BaseCard>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import BaseCard from './BaseCard.vue'
import ToastSuccessIcon from '@/assets/icons/toast-success.svg'
import ToastErrorIcon from '@/assets/icons/toast-error.svg'
import ToastInfoIcon from '@/assets/icons/toast-info.svg'
import { useI18n } from 'vue-i18n'

const { t } = useI18n({
	messages: {
		en: {
			dismiss: 'Dismiss'
		},
		ru: {
			dismiss: 'Скрыть'
		}
	}
})

const props = defineProps<{
	type: 'success' | 'error' | 'info'
	action?: string
	text: string
}>()

const emit = defineEmits<{
	(e: 'action'): void
}>()

const act = () => {
	emit('action')
}

const actionText = computed(() => {
	if (props.action) {
		return props.action
	}

	return t('dismiss')
})

const icon = computed(() => {
	switch (props.type) {
		case 'success':
			return ToastSuccessIcon
		case 'error':
			return ToastErrorIcon
		case 'info':
			return ToastInfoIcon
	}
})
</script>
